'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var StrategyReadonlyController = function StrategyReadonlyController($scope, configurationService, saveStrategyService, strategiesService, $log, featureToggleService) {
  $scope.trimPOS = function (value) {
    if (featureToggleService.isDisabled('SPOS')) {
      return _.trimEnd(value, 'POS');
    } else {
      return value;
    }
  };
  $scope.editStrategy = function () {
    $scope.closePanelHandler();
    $scope.$emit('strategy:editStrategy', $scope.strategy.basis, $scope.strategy);
  };
  $scope.isEditable = function () {
    var userDisplayName = configurationService.getUserDisplayName();
    var userId = configurationService.getUserId();
    var isOwner = userDisplayName === $scope.strategy.createdBy || userId === $scope.strategy.createdBy;
    return !$scope.strategy.isQuickRule && (isOwner || !$scope.strategy.isRestricted);
  };
  $scope.isPossibleToDuplicate = function () {
    return !$scope.strategy.isQuickRule;
  };
  $scope.duplicateStrategy = function () {
    var strategies = strategiesService.getStrategiesFromTemplate({
      basis: $scope.strategy.basis
    });
    var strategy = _.find(strategies, {
      name: $scope.strategy.name
    });
    saveStrategyService.duplicateStrategy(_.clone(strategy)).then(triggerDataChanged, handleDuplicatingError);
  };
  $scope.isEmptyCustom = function () {
    return $scope.strategy.basis === 'custom' && !$scope.strategy.groups.length;
  };
  $scope.changeStrategyListingVisibilityButtonHandler = function () {
    $scope.expandCollapseHandler();
  };
  $scope.formatFlowType = function (flowType) {
    return flowType ? _.capitalize(flowType.replace(/FlowType./g, '')) : '';
  };
  function triggerDataChanged(changedStrategy) {
    $scope.$emit('strategy:dataAndSelectionChanged', changedStrategy);
  }
  function handleDuplicatingError(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('StrategyReadonlyController: handleDuplicatingError - ' + message);
    toastr.error(message);
  }
};
StrategyReadonlyController.$inject = ['$scope', 'ConfigurationService', 'SaveStrategyService', 'StrategiesService', '$log', 'FeatureToggleService'];
module.exports = StrategyReadonlyController;